<template lang="pug">

  .welcome
    welcome-sprite(v-if="showWelcome" @complete="next")


</template>

<script>
  import WelcomeSprite from 'src/components/vca/widgets/WelcomeSprite3'
  import * as PATHS from 'src/router/paths'
  import BgPattern from "../widgets/BgPattern";

  export default {
    name: 'welcome',
    components: {
      BgPattern,
      WelcomeSprite,
    },
    data() {
      return {
        showWelcome: false
      }
    },
    props: {

    },
    computed: {

    },
    mounted() {
      // console.log(this.offset)
      // setTimeout(() => {
      //   this.next()
      // }, 2000)
      let cb = () => {
        this.showWelcome = true
      }
      window.App.welcomeSetup(cb)

    },
    beforeDestroy() {},
    methods: {

      next() {
        this.$router.replace({
          name: PATHS.DESTINATIONS,
        })
      },
    },
    watch: {},
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .welcome
    +full()
    .bg
      +full()
      background: linear-gradient(14.12deg, #B72D05 32.18%, #CF3503 80.69%)
      overflow: hidden
      z-index: 999
      .bg-pattern
        mix-blend-mode: difference
        //background: $cl-blue



</style>
